<template>
  <div class="row m-0" :class="editing ? 'column-editor':  ''">
    <div class="col-12">
      <label for="extra-duration">Custom name</label>
      <div class="input-group">
        <input type="text" id="customname" class="form-control" v-model="name">
        <div class="input-group-append">
          <span class="input-group-text extra-days"
                id="basic-addon2">name</span>
        </div>


        <input type="number" id="extra-duration" class="form-control" v-model="extraDuration">
        <div class="input-group-append">
          <span class="input-group-text extra-days"
                id="basic-addon2">{{ this.$tc('trackAndTrace.column.days', extraDuration) }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 " v-if="editing">
      <TrackAndTraceActivitiesPoolCustom :editing="true" :columns=customRoute.columns
                                         :amountOfColumns="maxAmountOfColumns"/>
    </div>

    <template v-if="editing">
      <div class="col-12 activity-columns">

        <div class="activity-column" v-for="column in getColumnsToShow" :key="'column-wrapper-' + column">

          <TrackAndTraceColumnCustom
              :jobs="getJobsOfColumn(column)"
              @labelChanged="setColumnLabel($event, column)"
              @subActivityChanged="emitColumnChange($event, column)"
              @listChanged="setColumnActivities($event, column)"
              :activityToShowDate="getLastFinishedActivity"
              :columns="customRoute.columns"
              :currentActivity="getCurrentActivity"
              :editing="editing" :columnIndex="column"
          />
        </div>

      </div>
    </template>
    <!--    <template v-else>-->

    <!--      <div :class="getColumnWidth[column]" class="col-12 activity-column" v-for="column in getColumnsToShow" :key="'column-wrapper-' + column">-->
    <!--          <TrackAndTraceColumn-->
    <!--              :jobs="getJobsOfColumn(column)"-->
    <!--              @labelChanged="setColumnLabel($event, column)"-->
    <!--              @listChanged="setColumnActivities($event, column)"-->
    <!--              @subActivityChanged="emitColumnChange($event, column)"-->
    <!--              :activityToShowDate="getLastFinishedActivity"-->
    <!--              :currentActivity="getCurrentActivity"-->
    <!--              :columns="getColumns"-->
    <!--              :editing="editing" :columnIndex="column"-->
    <!--          />-->
    <!--        </div>-->

    <!--    </template>-->
  </div>
</template>

<script>
import TrackAndTraceColumn from "../../components/trackAndTrace/TrackAndTraceColumn.vue";
import TrackAndTraceActivitiesPool from "../../components/trackAndTrace/TrackAndTraceActivitiesPool.vue";
import {mapGetters} from "vuex";
import TrackAndTraceColumnCustom from "./TrackAndTraceColumnCustom.vue";
import TrackAndTraceActivitiesPoolCustom from "./TrackAndTraceActivitiesPoolCustom.vue";

export default {
  name: "TrackAndTraceColumnsCustom",
  components: {TrackAndTraceActivitiesPoolCustom, TrackAndTraceColumnCustom},
  props: ['editing', 'jobs', 'customRoute'],
  data() {
    return {
      maxAmountOfColumns: 4,
      extraDuration: 0,
      name: null,
      // activitiesColumn0: {label: null, activities: []},
      // activitiesColumn1: {label: null, activities: []},
      // activitiesColumn2: {label: null, activities: []},
      // activitiesColumn3: {label: null, activities: []}
    }
  },
  computed: {
    ...mapGetters('trackAndTrace', ['getTrackAndTraceConfig']),
    ...mapGetters('jobs', ['getJobs']),
    getColumns() {
      return {
        activitiesColumn0: this.customRoute.columns.activitiesColumn0,
        activitiesColumn1: this.customRoute.columns.activitiesColumn1,
        activitiesColumn2: this.customRoute.columns.activitiesColumn2,
        activitiesColumn3: this.customRoute.columns.activitiesColumn3,
      }
    },
    getColumnWidth() {
      let columnWidths = ['col-lg', 'col-lg', 'col-lg', 'col-lg'];
      const columnsToShow = this.getColumnsToShow;
      for (let columnIndex = 0; columnIndex < columnsToShow.length; columnIndex++) {
        const column = columnsToShow[columnIndex];
        const lastColumn = columnIndex === columnsToShow.length - 1;

        if (lastColumn) {
          columnWidths[column] = 'col-lg'
        } else {
          const amountOfActivitiesInColumn = this[`activitiesColumn${column}`].activities.length;
          if (amountOfActivitiesInColumn >= 4) {
            columnWidths[column] = 'col-lg-4'
          } else {
            columnWidths[column] = 'col-lg'
          }
        }
      }
      return columnWidths;
    },
    getColumnsToShow() {
      if (this.editing) {
        let columnsToShow = [];
        for (let i = 0; i < this.maxAmountOfColumns; i++) {
          columnsToShow.push(i);
        }
        return columnsToShow;
      } else {
        let columnsToShow = [];

        for (let i = 0; i < this.maxAmountOfColumns; i++) {
          if (this.customRoute.columns[`activitiesColumn${i}`].activities.length) {
            columnsToShow.push(i);
          }
        }


        return columnsToShow;
      }
    },
    getLastFinishedActivity() {
      let lastFinishedActivity = null;
      for (let i = 0; i < this.maxAmountOfColumns; i++) {
        for (let a = 0; a < this[`activitiesColumn${i}`].activities.length; a++) {
          const activity = this[`activitiesColumn${i}`].activities[a];
          const jobWithActivity = _.find(this.jobs, {'activity': activity.value});
          if (jobWithActivity && jobWithActivity.status === 'finished') {
            lastFinishedActivity = activity.value;
          }
        }
      }
      return lastFinishedActivity;
    },
    getCurrentActivity() {
      let currentActivity = null;
      let previousActivityFinished = false;
      for (let i = 0; i < this.maxAmountOfColumns; i++) {
        for (let a = 0; a < this[`activitiesColumn${i}`].activities.length; a++) {
          const activity = this[`activitiesColumn${i}`].activities[a];
          const jobWithActivity = _.find(this.jobs, {'activity': activity.value});
          if (jobWithActivity && jobWithActivity.status === 'finished') {
            previousActivityFinished = true;
          } else if (previousActivityFinished) {
            previousActivityFinished = false;
            currentActivity = activity.value;
          }
        }
      }
      return currentActivity;
    }
  },
  methods: {
    emitColumnChange(event, column) {
      this.$emit('columnChanged', {columnIndex: column, data: event})
    },
    getJobsOfColumn(columnIndex) {
      return _.filter(this.jobs, job => {
        if (this[`activitiesColumn${columnIndex}`]) {
          const matchingActivitiesWithJob = _.find(this[`activitiesColumn${columnIndex}`].activities, {'value': job.activity});
          if (matchingActivitiesWithJob) {
            return true;
          } else {
            return false;
          }
        }
      })
    },
    setColumnActivities(data, columnIndex) {
      this[`activitiesColumn${columnIndex}`].activities = data;
    },
    setColumnLabel(data, columnIndex) {
      this[`activitiesColumn${columnIndex}`].label = data;
    }
  },
  created() {
    this.name = this.customRoute.name

    for (let i = 0; i < this.maxAmountOfColumns; i++) {
      this[`activitiesColumn${i}`] = this.customRoute.columns[`activitiesColumn${i}`];
    }
    this.extraDuration = this.customRoute.extraDuration ? this.customRoute.extraDuration : this.extraDuration;
  },
  watch: {
    'name': {
      handler(newValue) {
        this.$emit('nameChanged', newValue);
      }
    },
    // 'activitiesColumn0': {
    //   deep: true,
    //   handler(newValue) {
    //     this.$emit('columnChanged', {columnIndex: 0, data: newValue})
    //   }
    // },
    // 'activitiesColumn1': {
    //   deep: true,
    //   handler(newValue) {
    //     this.$emit('columnChanged', {columnIndex: 1, data: newValue})
    //   }
    // },
    // 'activitiesColumn2': {
    //   deep: true,
    //   handler(newValue) {
    //     this.$emit('columnChanged', {columnIndex: 2, data: newValue})
    //   }
    // },
    // 'activitiesColumn 4': {
    //   deep: true,
    //   handler(newValue) {
    //     this.$emit('columnChanged', {columnIndex: 3, data: newValue})
    //   }
    // },
    'extraDuration': {
      handler(newValue) {
        this.$emit('extraDurationChanged', newValue);
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";

.column-editor {
  border: 1px solid $cultured;
  padding: 2rem;
  margin: 1rem !important;
}

.remaining-time-col {
  margin-bottom: 1rem;
}

.activity-column {
  padding-bottom: 2rem;
}

@media only screen and (max-width: 900px) {
  .activity-column {
    padding: 8px !important;
  }

  .activity-column:last-child {
    padding-bottom: 2rem !important;
  }
}


.activity-columns {
  display: grid;
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
}

#extra-duration {
  margin-bottom: 12px;
}

.extra-days {
  margin-bottom: 12px;
  padding: 4px 12px;
  width: 100px;
  background-color: $softGrey;
  color: inherit;
  height: 49px;
}


/* The input */
/deep/ .tags-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

/deep/ .tags-input input {
  flex: 1;
  background: transparent;
  border: none;
}

/deep/ .tags-input input:focus {
  outline: none;
}

/deep/ .tags-input input[type="text"] {
  color: #495057;
}

/deep/ .tags-input-wrapper-default {
  padding: .5em .25em;
  background: #fff;
  border: 1px solid transparent;
  border-radius: 0em;
  border-color: #dbdbdb;
}

/deep/ .tags-input-wrapper-default.active {
  /*border: 1px solid #8bbafe;*/
  /*box-shadow: 0 0 0 0.2em rgba(13, 110, 253, 0.25);*/
  /*outline: 0 none;*/
  border-color: $ceruleanBlue;
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

/* The tag badges & the remove icon */
.tags-input span {
  margin-right: 0.3em;
}

/deep/ .tags-input-remove {
  cursor: pointer;
  position: absolute;
  display: inline-block;
  right: 0.3em;
  top: 0.3em;
  padding: 0.5em;
  overflow: hidden;
}

/deep/ .tags-input-remove:focus {
  outline: none;
}

/deep/ .tags-input-remove:before, .tags-input-remove:after {
  content: '';
  position: absolute;
  width: 75%;
  left: 0.15em;
  background: #5dc282;

  height: 2px;
  margin-top: -1px;
}

/deep/ .tags-input-remove:before {
  transform: rotate(45deg);
}

/deep/ .tags-input-remove:after {
  transform: rotate(-45deg);
}

/* Tag badge styles */
/deep/ .tags-input-badge {
  position: relative;
  display: inline-block;
  padding: 0.25em 0.4em;
  /*font-size: 75%;*/
  /*font-weight: 700;*/
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .tags-input-badge-pill {
  padding-right: 1.25em;
  padding-left: 0.6em;
  border-radius: 10em;
}

/deep/ .tags-input-badge-pill.disabled {
  padding-right: 0.6em;
}

/deep/ .tags-input-badge-selected-default {
  color: #212529;
  background-color: #f0f1f2;
}

/* Typeahead */
/deep/ .typeahead-hide-btn {
  color: #999 !important;
  font-style: italic;
}

/* Typeahead - badges */
/deep/ .typeahead-badges > span {
  margin-top: .5em;
}

/deep/ .typeahead-badges > span {
  cursor: pointer;
  margin-right: 0.3em;
}

/* Typeahead - dropdown */
/deep/ .typeahead-dropdown {
  list-style-type: none;
  padding: 0;
  margin: 0;
  position: absolute;
  height: 200px;
  width: 100%;
  z-index: 9999999999999999;

  max-height: 300px; /* Adjust this value to suit your design */
  overflow-y: auto; /* Allow vertical scrolling if necessary */

}

/deep/ .typeahead-dropdown li {
  padding: .25em 1em;
  cursor: pointer;
}

/* Typeahead elements style/theme */
/deep/ .tags-input-typeahead-item-default {
  background-color: #ffffff;
  border-left: 1px solid $ceruleanBlue;
  border-right: 1px solid $ceruleanBlue;
}


/deep/ .typeahead-dropdown {
  max-height: 30rem;
  overflow-y: auto;
  border-bottom: 1px solid $ceruleanBlue;

}

/deep/ .tags-input-typeahead-item-highlighted-default {
  color: #fff;
  background-color: $ceruleanBlue !important;
}
</style>